import Immutable from "immutable";
import { take, select, fork, cancel, put } from "redux-saga/effects";
import { isProductAvailable } from "lib/validate";
import { FETCH_AVAILABLE_PRODUCTS_COMPLETE, productSagasAttached } from "state/app/actions";
import { getAvailableProducts } from "state/app/selectors";

import teachersSaga from "state/teachers/sagas";
import schoolMoneySaga from "state/school_money/sagas";

const productSagas = Immutable.Map({
  teachers: teachersSaga,
  school_money: schoolMoneySaga
});

/**
 * Each time availableProducts is refreshed, attach or detach
 *   product sagas so that we always have the right set running.
 */
export default function* attachProductsSaga() {

  // this is why we are using a while..take loop instead of a takeEvery
  // we need to maintain a record of what sagas are running
  // so we can add/remove as appropriate
  let runningProducts = Immutable.Map();

  while (true) {

    // wait for new availableProducts
    yield take(FETCH_AVAILABLE_PRODUCTS_COMPLETE);

    // get current and previous availableProducts
    const availableProductList = yield select(getAvailableProducts);
    const availableProducts = availableProductList.toSet();
    const previousAvailableProducts = runningProducts.keySeq().toSet();

    // joining: products that weren't available before but are now
    const joiningProducts = availableProducts.subtract(previousAvailableProducts);
    // leaving: products that were available before but aren't now
    const leavingProducts = previousAvailableProducts.subtract(availableProducts);

    // cancel sagas of leaving products
    // NOTE: if these sagas spawned (not forked) others, those will
    //   not be cancelled unless explicitly (in a finally block)
    for (const product of leavingProducts) {
      const productTask = runningProducts.get(product);
      yield cancel(productTask);
      runningProducts = runningProducts.delete(product);
    }

    // attach sagas of joining products
    for (const product of joiningProducts) {
      if (isProductAvailable(product)) {
        const productSaga = productSagas.get(product);
        const productTask = yield fork(productSaga);
        runningProducts = runningProducts.set(product, productTask);
      } else if (runningProducts.contains(product)) {
        const productTask = runningProducts.get(product);
        yield cancel(productTask);
        runningProducts = runningProducts.delete(product);
      }
    }

    yield put(productSagasAttached());

  }

}



// WEBPACK FOOTER //
// ./src/state/app/sagas/attachProductsSaga.js